import { useState, useEffect, memo } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { checkboxData } from "./checkboxData";
import "./style.css";
import { useUserAuth } from "../../context/UserAuthContext";
import { templeTtkSchema, venueTtkSchema } from "../schemas";
import { useFormik } from "formik";
import axios from "axios";
import { NumericFormat } from "react-number-format";
import ThinksToKnowStatus from "./ThinksToKnowStatus";

const TempleTTK = () => {
    const { language } = useUserAuth();
    const {
        djPolicyOption,
        decorPolicyOption,
        caterPolicyOptions,
        alcoholPolicyOption,
        // workSinceOption,
        spaceOption,
        // smallPartyOption,
    } = checkboxData;
    const { user, token , currency} = useUserAuth();
    const merchant_id = user.uid;
    const [merchant, setMerchant] = useState({});
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const [ttkEditMode, setTtkEditMode] = useState(false);
    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(
                `${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            const data = res?.data?.data;
            const details = data[0].details;
            // const details = rawDetails ? JSON.parse(rawDetails) : null;
            if (details) {
                const keysLength = Object.keys(details)?.length;
                setMerchant(data[0]?.details);
                formik.setValues(data[0].details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };
    useEffect(() => {
        if (!merchant_id) return
        getSingleDocumentHandler();
    }, [merchant_id, token]);
    const formik = useFormik({
        initialValues: {
            parkingSize: merchant?.parkingSize || "",
            vegPrice: Math.floor(merchant?.vegPrice * currency.value) || "",
            nonVegPrice: Math.floor(merchant?.nonVegPrice * currency.value) || "",
            venueCapacity: merchant?.venueCapacity || "",
            space: merchant?.space || [],
            catering: merchant?.catering || [],
            decorPolicy: merchant?.decorPolicy || [],
            alcoholPolicy: merchant?.alcoholPolicy || [],
            djPolicy: merchant?.djPolicy || [],
            best_duration_from: merchant?.best_duration_from || "",
            best_duration_to: merchant?.best_duration_to || "",
        },
        enableReinitialize: true,
        validationSchema: templeTtkSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    id: merchant_id,
                    details: { ...values, vegPrice: Math.floor(values.vegPrice * currency.country_value), nonVegPrice: Math.floor(values.nonVegPrice * currency.country_value) },
                };
                const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                } else {
                    toast.info(res.data.message || "Request submitted.");
                }
                setTtkEditMode(!ttkEditMode);
                const updated_data = {
                    ...merchant,
                    thingsToKnow: {
                        ...values,
                    },
                };
                setMerchant(updated_data);
                getSingleDocumentHandler();
            } catch (error) {
                console.error(`Error ${error}`);
                toast.error("An error occurred while updating the data.");
            }
        },
    });
    const monthsOptions = [
        { value: "January", label: "January" },
        { value: "February", label: "February" },
        { value: "March", label: "March" },
        { value: "April", label: "April" },
        { value: "May", label: "May" },
        { value: "June", label: "June" },
        { value: "July", label: "July" },
        { value: "August", label: "August" },
        { value: "September", label: "September" },
        { value: "October", label: "October" },
        { value: "November", label: "November" },
        { value: "December", label: "December" },
    ];
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                 <ThinksToKnowStatus/>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div
                                className="card-header  text-white text-center "
                                style={{ backgroundColor: "#085f9a" }}
                            >
                                <h5>
                                    {language === "en"
                                        ? "Things to Know"
                                        : "जानने योग्य जानकारी भरे"}
                                </h5>
                            </div>
                            <div className="card-body">
                                {merchant && (
                                    <>
                                        <div className="table-responsive">
                                            <table
                                                className="table text-center"
                                                cellPadding={0}
                                                cellSpacing={0}
                                                style={{ border: "1px solid #fff " }}
                                            >
                                                <tbody className="ttk_preview">
                                                    <tr style={{ color: "#41B0FA" }}>
                                                        <th style={{ width: "25%" }}>
                                                            Max Capacity
                                                        </th>
                                                        <th style={{ width: "25%" }}>
                                                            How many cars can be parked at your venue?{" "}
                                                        </th>
                                                        <th style={{ width: "25%" }}>
                                                            Starting Veg Price (Per Plate){" "}
                                                        </th >
                                                        <th style={{ width: "25%" }}
                                                        >Starting Non Veg Price (Per Plate)
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td>{merchant?.venueCapacity}</td>
                                                        <td>{merchant?.parkingSize}</td>
                                                        <td><NumericFormat
                                                            value={Math.floor(
                                                                currency.value * merchant.vegPrice
                                                            )}
                                                            displayType="text"
                                                            thousandsGroupStyle={
                                                                currency.symbol === "₹" ? "lakh" : "thousand"
                                                            }
                                                            thousandSeparator=","
                                                            renderText={(formattedValue) => (
                                                                <span>
                                                                    {currency.symbol}&nbsp;{formattedValue}
                                                                </span>
                                                            )}
                                                        />
                                                            <small
                                                                className="text-success"
                                                                style={{
                                                                    fontWeight: "bold",
                                                                }}
                                                            >
                                                                Per Plate
                                                            </small>
                                                        </td>

                                                        <td>
                                                            <NumericFormat
                                                                value={Math.floor(
                                                                    currency.value * merchant.nonVegPrice
                                                                )}
                                                                displayType="text"
                                                                thousandsGroupStyle={
                                                                    currency.symbol === "₹" ? "lakh" : "thousand"
                                                                }
                                                                thousandSeparator=","
                                                                renderText={(formattedValue) => (
                                                                    <span>
                                                                        {currency.symbol}&nbsp;{formattedValue}
                                                                    </span>
                                                                )}
                                                            />
                                                            <small
                                                                className="text-danger"
                                                                style={{
                                                                    fontWeight: "bold",
                                                                }}
                                                            >
                                                                Per Plate
                                                            </small>
                                                        </td>
                                                    </tr>
                                                    <tr style={{ color: "#41B0FA" }}>
                                                        <th>Space</th>
                                                        <th>Catering Policy</th>
                                                        <th>Dj Policy</th>
                                                        <th>Decor Policy</th>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {merchant.space?.map((item, index) => {
                                                                return (
                                                                    <p key={index}>
                                                                        <i className="fa fa-check text-success" />
                                                                        <span>{item.value} </span>
                                                                    </p>
                                                                );
                                                            })}
                                                        </td>
                                                        <td>
                                                            {merchant.catering?.map((item, index) => {
                                                                return (
                                                                    <p key={index}>
                                                                        <i className="fa fa-check text-success" />
                                                                        <span>{item.value} </span>
                                                                    </p>
                                                                );
                                                            })}
                                                        </td>
                                                        <td>
                                                            {merchant.djPolicy?.map((item, index) => {
                                                                return (
                                                                    <p key={index}>
                                                                        <i className="fa fa-check text-success" />
                                                                        <span>{item.value}</span>
                                                                    </p>
                                                                );
                                                            })}
                                                        </td>
                                                        <td>
                                                            {merchant.decorPolicy?.map((item, index) => {
                                                                return (
                                                                    <p key={index}>
                                                                        <i className="fa fa-check text-success" />
                                                                        <span >{item.value} </span>
                                                                    </p>
                                                                );
                                                            })}
                                                        </td>
                                                    </tr>
                                                    <tr style={{ color: "#41B0FA" }}>
                                                        <th>Alcohol Policy </th>
                                                        <th>Best Duration to Plan </th>
                                                    </tr>
                                                    <tr>
                                                        <td> 
                                                            {merchant.alcoholPolicy?.map((item, index) => {
                                                                return (
                                                                    <p key={index}>
                                                                        <i className="fa fa-check text-success" />
                                                                        <span key={index}>{item.value} </span>
                                                                    </p>
                                                                );
                                                            })}
                                                        </td>
                                                        <td>{merchant?.best_duration_from}{merchant?.best_duration_from && 'To'}{merchant?.best_duration_to}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                )}
                                <center>
                                    <button
                                        className="btn btn-primary mb-2 text-white"
                                        style={{ backgroundColor: "#085f9a" }}
                                        onClick={() => setTtkEditMode(!ttkEditMode)}
                                    >{`${merchant ? "Make Changes" : "Tell me more about yourself"
                                        }`}</button>
                                </center>
                                {ttkEditMode && (
                                    <form onSubmit={formik.handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>
                                                        How many cars can be parked at your venue?{" "}
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="number"
                                                        placeholder="How many cars can be parked at your venue?"
                                                        name="parkingSize"
                                                        className="form-control"
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.parkingSize}
                                                    />
                                                    {formik.touched.parkingSize &&
                                                        formik.errors.parkingSize ? (
                                                        <div className="text-danger">
                                                            {formik.errors.parkingSize}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="" htmlFor="inlineFormInputGroup">  Starting Veg Price (Per Plate)   <span className="text-danger">*</span></label>
                                                <div className="input-group mb-2">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">{currency?.symbol}</div>
                                                    </div>
                                                    <input
                                                        type="number"
                                                        placeholder="Veg Price Per Plate"
                                                        name="vegPrice"
                                                        className="form-control"
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.vegPrice} />
                                                </div>
                                                {formik.touched.vegPrice && formik.errors.vegPrice ? (
                                                    <div className="text-danger">
                                                        {formik.errors.vegPrice}
                                                    </div>
                                                ) : null}
                                            </div>

                                            <div className="col-md-6">
                                                <label className="" htmlFor="inlineFormInputGroup"> Non Starting Veg Price (Per Plate) <span className="text-danger">*</span></label>
                                                <div className="input-group mb-2">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">{currency?.symbol}</div>
                                                    </div>
                                                    <input
                                                        type="number"
                                                        placeholder="Non Veg Price Per Plate"
                                                        name="nonVegPrice"
                                                        className="form-control"
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.nonVegPrice} />
                                                </div>
                                                {formik.touched.nonVegPrice && formik.errors.nonVegPrice ? (
                                                    <div className="text-danger">
                                                        {formik.errors.nonVegPrice}
                                                    </div>
                                                ) : null}
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>
                                                        Space <span className="text-danger">*</span>
                                                    </label>
                                                    <Select
                                                        closeMenuOnSelect={false}
                                                        isMulti
                                                        options={spaceOption}
                                                        selected
                                                        value={formik.values.space}
                                                        onChange={(space) =>
                                                            formik.setFieldValue("space", space)
                                                        }
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.space && formik.errors.space ? (
                                                        <div className="text-danger">
                                                            {formik.errors.space}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>
                                                        Catering Policy{" "}
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <Select
                                                        closeMenuOnSelect={false}
                                                        isMulti
                                                        options={caterPolicyOptions}
                                                        selected
                                                        value={formik.values.catering}
                                                        onChange={(catering) =>
                                                            formik.setFieldValue("catering", catering)
                                                        }
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.catering && formik.errors.catering ? (
                                                        <div className="text-danger">
                                                            {formik.errors.catering}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>
                                                        Decor Policy <span className="text-danger">*</span>
                                                    </label>
                                                    <Select
                                                        closeMenuOnSelect={false}
                                                        isMulti
                                                        options={decorPolicyOption}
                                                        selected
                                                        value={formik.values.decorPolicy}
                                                        onChange={(decorPolicy) =>
                                                            formik.setFieldValue("decorPolicy", decorPolicy)
                                                        }
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.decorPolicy &&
                                                        formik.errors.decorPolicy ? (
                                                        <div className="text-danger">
                                                            {formik.errors.decorPolicy}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>
                                                        Alcohol Policy{" "}
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <Select
                                                        closeMenuOnSelect={false}
                                                        isMulti
                                                        options={alcoholPolicyOption}
                                                        selected
                                                        value={formik.values.alcoholPolicy}
                                                        onChange={(alcoholPolicy) =>
                                                            formik.setFieldValue(
                                                                "alcoholPolicy",
                                                                alcoholPolicy
                                                            )
                                                        }
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.alcoholPolicy &&
                                                        formik.errors.alcoholPolicy ? (
                                                        <div className="text-danger">
                                                            {formik.errors.alcoholPolicy}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>
                                                        DJ Policy <span className="text-danger">*</span>
                                                    </label>
                                                    <Select
                                                        closeMenuOnSelect={true}
                                                        isMulti
                                                        options={djPolicyOption}
                                                        selected
                                                        value={formik.values.djPolicy}
                                                        onChange={(djPolicy) =>
                                                            formik.setFieldValue("djPolicy", djPolicy)
                                                        }
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.djPolicy && formik.errors.djPolicy ? (
                                                        <div className="text-danger">
                                                            {formik.errors.djPolicy}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>
                                                        Max Capacity <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="Venue Capacity"
                                                        name="venueCapacity"
                                                        className="form-control"
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.venueCapacity}
                                                    />
                                                    {formik.touched.venueCapacity &&
                                                        formik.errors.venueCapacity ? (
                                                        <div className="text-danger">
                                                            {formik.errors.venueCapacity}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            {/* BEST DURATION SECTION */}
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>
                                                        Best Duration to Plan <span className="text-danger">*</span>
                                                    </label>
                                                    <div className="row align-items-center">
                                                        {/* FROM MONTH */}
                                                        <div className="col-md-5">
                                                            <Select
                                                                options={monthsOptions}
                                                                name="best_duration_from"
                                                                value={monthsOptions.find(option => option.value === formik.values.best_duration_from)}
                                                                onChange={(option) =>
                                                                    formik.setFieldValue("best_duration_from", option ? option.value : "")
                                                                }
                                                                onBlur={formik.handleBlur}
                                                                placeholder="From Month"
                                                            />
                                                            {formik.touched.best_duration_from && formik.errors.best_duration_from && (
                                                                <div className="text-danger">{formik.errors.best_duration_from}</div>
                                                            )}
                                                        </div>

                                                        {/* “TO” TEXT */}
                                                        <div className="col-md-2 text-center fw-bold ">To</div>

                                                        {/* TO MONTH */}
                                                        <div className="col-md-5">
                                                            <Select
                                                                options={monthsOptions}
                                                                name="best_duration_to"
                                                                value={monthsOptions.find(option => option.value === formik.values.best_duration_to)}
                                                                onChange={(option) =>
                                                                    formik.setFieldValue("best_duration_to", option ? option.value : "")
                                                                }
                                                                onBlur={formik.handleBlur}
                                                                placeholder="To Month"
                                                            />
                                                            {formik.touched.best_duration_to && formik.errors.best_duration_to && (
                                                                <div className="text-danger">{formik.errors.best_duration_to}</div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group text-center">
                                            <button
                                                type="submit"
                                                className="btn text-white"
                                                style={{ backgroundColor: "#085f9a" }}
                                            >
                                                {ttkEditMode ? "Save Changes" : "Submit"}
                                            </button>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(TempleTTK);